import React from "react";

const i18n = require('react-redux-i18n').I18n;

const DemographicOptions = ({ options, label, name, demographicOnChange }) => {
    if (Array.isArray(options[0])) {
        // options = [["", <Translate value="select" />], ...options];
        options = [["", i18n.t("select")], ...options];
    } else {
        // options = [{ id: "", name: <Translate value="select" /> }, ...options];
        options = [{ id: "", name: i18n.t("select") }, ...options];
    }

    const selections = options.map((option, index) => {
        if (Array.isArray(option)) {
            return (
                <option key={index} value={option[0]}>
                    {option[1]}
                </option>
            );
        }
        return (
            <option key={index} value={option.id}>
                {option.name}
            </option>
        );
    });

    const handleOnChange = event => {
        const value = event.target.value;
        demographicOnChange(value);
    };

    return (
        <div className="form-group">
            <p className="est text-left mb-1">{label}:</p>
            <select
                className="form-control demographics"
                name={name}
                onChange={handleOnChange}
            >
                {selections}
            </select>
        </div>
    );
};

export default DemographicOptions;
